import React from "react";

export default function ProductionStats({ stats }) {
    return (
        <section className="production-stats">
            <div className="production-inner production-stats-row">
                {stats.map(([value, label]) => (
                    <div className="production-stat" key={value}>
                        <strong>{value}</strong>
                        <span>{label}</span>
                    </div>
                ))}
            </div>
        </section>
    );
}
